import { PaymentMethodType } from '@nemuru-eng/js-api-client';

import { AbstractSinglePaymentMethod } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/PaymentMethod/AbstractSinglePaymentMethod';
import { PaymentMethodRequestType } from '@/components/modules/Application/components/PaymentMethod/_shared/types/PaymentMethodRequestType';

type SinglePaymentMethodRequest = PaymentMethodRequestType<
  PaymentMethodType.CARD_PAYMENT | PaymentMethodType.A2A_PAYMENT
>;

export class SinglePaymentMethod extends AbstractSinglePaymentMethod {
  protected ALLOWED_PAYMENT_METHOD_TYPES = [PaymentMethodType.CARD_PAYMENT, PaymentMethodType.A2A_PAYMENT];

  public toDto(): SinglePaymentMethodRequest {
    return {
      type: this.paymentMethodType as SinglePaymentMethodRequest['type'],
    };
  }
}
